import type { RouteObject } from 'react-router';
import { RequirePermission } from '@/app/require-permission';
import { AssistantPage } from './assistant-page';
import { NotificationsPage } from './notifications-page';

export const appRoutes: RouteObject[] = [
  {
    path: 'assistente',
    element: (
      <RequirePermission anyOf={['ai.use']}>
        <AssistantPage />
      </RequirePermission>
    ),
  },
  {
    path: 'notificacoes',
    element: (
      <RequirePermission anyOf={['settings.manage']}>
        <NotificationsPage />
      </RequirePermission>
    ),
  },
];
